/* eslint-disable */
import {FuseNavigationItem} from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'Dashboards',
        subtitle: '',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'dashboards.overview',
                title: 'Overview',
                type: 'basic',
                icon: 'heroicons_outline:squares-2x2',
                link: '/dashboards/overview'
            },
            {
                id: 'dashboards.operation',
                title: 'Operation',
                type: 'basic',
                icon: 'heroicons_outline:chart-bar',
                link: '/operations/dashboard'
            }
        ]
    },
    {
        id: 'operations',
        title: 'Operations',
        subtitle: 'Orders, SLA, credits & analytics',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'operations.orders',
                title: 'Orders',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-check',
                link: '/operations/orders'
            },
            {
                id: 'operations.credits',
                title: 'Credits',
                type: 'basic',
                icon: 'heroicons_outline:credit-card',
                link: '/operations/credits'
            },
            // {
            //     id   : 'payments.history',
            //     title: 'History',
            //     type : 'basic',
            //     icon : 'heroicons_outline:clipboard-document-check',
            //     link : '/payments/history'
            // },
            // {
            //     id   : 'payments.documents',
            //     title: 'Documents',
            //     type : 'basic',
            //     icon : 'heroicons_outline:clipboard-document-check',
            //     link : '/payments/documents'
            // }
        ]
    },
    {
        id: 'system',
        title: 'System',
        subtitle: 'Monitoring and administration',
        type: 'group',
        icon: 'heroicons_outline:cog-6-tooth',
        children: [
            {
                id: 'system.logs',
                title: 'Logs',
                type: 'collapsable',
                icon: 'heroicons_outline:document-text',
                children: [
                    {
                        id: 'system.logs.dashboard',
                        title: 'Dashboard',
                        type: 'basic',
                        icon: 'heroicons_outline:chart-bar',
                        link: '/logs/dashboard'
                    },
                    {
                        id: 'system.logs.viewer',
                        title: 'Log Viewer',
                        type: 'basic',
                        icon: 'heroicons_outline:magnifying-glass',
                        link: '/logs/viewer'
                    }
                ]
            },
            {
                id: 'system.queues',
                title: 'Queues',
                type: 'basic',
                icon: 'heroicons_outline:queue-list',
                link: '/queues'
            },
        ]
    },

    {
        id: 'companies',
        title: 'Companies',
        subtitle: 'Management of all companies',
        type: 'group',
        children: [
            {
                id: 'companies.list',
                title: 'Companies',
                type: 'basic',
                icon: 'heroicons_outline:building-office-2',
                link: '/companies'
            }
        ]
    },

    {
        id: 'mails-app',
        title: 'Mails',
        type: 'group',
        children: [
            {
                id: 'mails-app.stats',
                title: 'Stats',
                type: 'basic',
                icon: 'heroicons_outline:chart-pie',
                link: '/mails/stats'
            },
            {
                id: 'mails-app.list',
                title: 'Mails Tracking ',
                type: 'basic',
                icon: 'heroicons_outline:envelope',
                link: '/mails',
                exactMatch: true,
            }
        ]
    },
    {
        id: 'front-app',
        title: 'Front App',
        subtitle: 'Management of all front app things',
        type: 'group',
        children: [
            {
                id: 'front-app.list',
                title: 'Front App Conversations Reviews',
                type: 'basic',
                icon: 'heroicons_outline:pencil-square',
                link: '/front-app'
            }
        ]
    },
    {
        id: 'websites',
        title: 'Websites',
        subtitle: 'Manage of CDE/CDM websites like Qonto, Sumeria',
        type: 'group',
        icon: '',
        children: [
            {
                id: 'offers',
                title: 'Offers',
                type: 'basic',
                icon: 'heroicons_outline:pencil-square',
                link: '/websites/offers'
            },
            {
                id: 'evasions',
                title: 'Evasions',
                type: 'basic',
                icon: 'heroicons_outline:pencil-square',
                link: '/websites/evasions'
            }

        ]
    },
    {
        id: 'resources',
        title: 'Resources',
        subtitle: 'Management of all website resources',
        type: 'group',
        icon: 'heroicons_outline:folder-open',
        children: [
            {
                id: 'users',
                title: 'Users',
                type: 'basic',
                icon: 'heroicons_outline:user-group',
                link: '/users'
            },
            {
                id: 'staff',
                title: 'Staff',
                type: 'basic',
                icon: 'heroicons_outline:identification',
                link: '/staff'
            },
            {
                id: 'subscriptions',
                title: 'Subscriptions',
                type: 'collapsable',
                icon: 'heroicons_outline:user-group',
                children: [
                    {
                        id: 'subscriptions.list',
                        title: 'List',
                        type: 'basic',
                        icon: 'heroicons_outline:tag',
                        link: '/subscriptions'
                    },
                    {
                        id: 'subscriptions.plans',
                        title: 'Plans',
                        type: 'basic',
                        icon: 'heroicons_outline:tag',
                        link: '/subscriptions/plans'
                    }
                ]
            },
            {
                id: 'offers',
                title: 'Offers',
                type: 'collapsable',
                icon: 'heroicons_outline:tag',
                children: [
                    {
                        id: 'offers.list',
                        title: 'List',
                        type: 'basic',
                        icon: 'heroicons_outline:tag',
                        link: '/offers',
                        exactMatch: true,

                    },
                    {
                        id: 'offers.categories',
                        title: 'Categories',
                        type: 'basic',
                        icon: 'heroicons_outline:tag',
                        link: '/offers/categories'
                    },
                ]
            },
            {
                id: 'services',
                title: 'Services',
                type: 'collapsable',
                icon: 'heroicons_outline:tag',
                children: [
                    {
                        id: 'services.list',
                        title: 'List',
                        type: 'basic',
                        icon: 'heroicons_outline:tag',
                        link: '/services',
                        exactMatch: true,
                    },
                    {
                        id: 'services.categories',
                        title: 'Categories',
                        type: 'basic',
                        icon: 'heroicons_outline:tag',
                        link: '/services/categories'
                    },
                    {
                        id: 'services.sla-config',
                        title: 'SLA Config',
                        type: 'basic',
                        icon: 'heroicons_outline:clock',
                        link: '/sla-config'
                    },
                    {
                        id: 'services.mapping',
                        title: 'Service Mapping',
                        type: 'basic',
                        icon: 'heroicons_outline:arrows-right-left',
                        link: '/service-mapping'
                    },
                ]
            },
            // {
            //     id: 'events',
            //     title: 'Events',
            //     type: 'basic',
            //     icon: 'heroicons_outline:tag',
            //     link: '/events',
            // },
            {
                id: 'suggestions',
                title: 'Suggestions',
                type: 'basic',
                icon: 'heroicons_outline:tag',
                link: '/suggestions',
            },
            {
                id: 'news',
                title: 'News',
                type: 'basic',
                icon: 'heroicons_outline:tag',
                link: '/news',
            },
            // {
            //     id: 'compliments',
            //     title: 'Compliments',
            //     type: 'basic',
            //     icon: 'heroicons_outline:tag',
            //     link: '/compliments',
            // },
            // {
            //     id: 'content',
            //     title: 'Content',
            //     type: 'basic',
            //     icon: 'heroicons_outline:tag',
            //     link: '/contents',
            // }
        ],
    },

];
export const compactNavigation: FuseNavigationItem[] = [];
export const futuristicNavigation: FuseNavigationItem[] = [];
export const horizontalNavigation: FuseNavigationItem[] = [];
